module.exports = __webpack_public_path__ + "9e56c960a0ffe8a2db436bef37098dcb.pdf";